<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.car')"
      filterable
      clearable
      :disabled="disabled"
      :size="size"
      class="d-block"
      :multiple="multiple"
    >
      <el-option
        v-for="(guestCar, index) in guestCarsList"
        :key="'guestCompanies-' + index"
        :label="guestCar.model"
        :value="guestCar.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    guest_id: {
      default: null,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    guest_id: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.selected = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.guestCars && this.guestCars.length === 0) {
      this.updateInventory();
    }
  },
  computed: {
    ...mapGetters({
      guestCars: "guestCar/inventory",
    }),
    guestCarsList: function () {
      if (!this.guest_id) {
        return this.guestCars;
      }
      if (this.guest_id) {
        let filteredCars = _.filter(this.guestCars, [ "guest_id",this.guest_id]);
        if (filteredCars.length == 1) {
          this.dispatch(filteredCars[0].id);
          return filteredCars;
        }
        return filteredCars;
      }
    },
  },
  methods: {
    ...mapActions({
      updateInventory: "guestCar/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
      this.$emit("refreshGuestId", _.find(this.guestCars, ["id", e]).guest_id);
    },
  },
};
</script>
